import React, { useState } from 'react';
import { updateDoc } from 'firebase/firestore';
import logger from '../../utils/logger';

export function InlineModerationRating({ document, readOnly = false }) {
  const [currentRating, setCurrentRating] = useState(document.moderationRating || 0);
  const [hoverRating, setHoverRating] = useState(0);

  const handleRate = async (rating) => {
    if (readOnly) return;
    try {
      const docRef = document.ref;
      await updateDoc(docRef, { moderationRating: rating });
      setCurrentRating(rating);
      document.moderationRating = rating;
    } catch (err) {
      logger.error('Error updating moderation rating:', err);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex">
        {[...Array(5)].map((_, index) => {
          const starValue = index + 1;
          const isFilled = starValue <= (hoverRating || currentRating);
          return (
            <span
              key={starValue}
              className={`text-lg leading-none mx-px transition-colors ${
                isFilled ? 'text-yellow-400' : 'text-gray-300'
              } ${readOnly ? 'cursor-default' : 'cursor-pointer hover:scale-110'}`}
              onMouseEnter={() => !readOnly && setHoverRating(starValue)}
              onMouseLeave={() => !readOnly && setHoverRating(0)}
              onClick={() => handleRate(starValue)}
            >
              ★
            </span>
          );
        })}
      </div>
      <span className="text-[11px] text-gray-400 mt-0.5">
        {currentRating ? `${currentRating}/5` : 'Unrated'}
      </span>
    </div>
  );
}
